
				var addMethods = require("../../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["receiveMessageFromMaster"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "4372f3384d2138ce5209.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			